import { useCallback } from 'react';
import useSWR from 'swr';

export type AlltracexExchangeData = {
  marketSupply: number | 0;
  base: string | '';
  token: string | '';
  rate: number | 0;
  marketCap: number | 0;
  perToken: number | 0;
}
export type Ticker = {
  address: string;
  name: string;
  symbol: string;
  decimals: number;
  rate: number;
  perToken: number;
}
type GetAllTokensDatas = {
  baseCurrency: string | '';
  rates: Array<Ticker> | [];
}

export default function usePrice() {
  const fetchData = async() => {
    try {
      const res = await fetch('https://alltra.azurewebsites.net/api/reserve-pricing?from=AUD');
      if (res.ok) {
        const data = await res.json() as AlltracexExchangeData;
        return data;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
  const fetchDataToken = async() => {
    try {
      let dataTicker: Array<Ticker> = [];
      const response = await (await fetch('https://alltra.azurewebsites.net/api/alltra-pricing?base=AUD')).json() as GetAllTokensDatas;
      if (response.rates) {
        dataTicker = response.rates;
      }
      const responseGithub = await (await fetch('https://raw.githubusercontent.com/lloydgalley/frontend-configs/master/configs/tokens/config.json')).json() as GetAllTokensDatas;
      if (responseGithub.rates) {
        dataTicker = dataTicker.concat(responseGithub.rates);
      }
      return dataTicker;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  const { data: priceAll } = useSWR('priceAll', () => fetchData(), { revalidateOnFocus: false, ttl: 60000, dedupingInterval: 15000 });

  const { data: priceToken } = useSWR('priceToken', () => fetchDataToken(), { revalidateOnFocus: false, ttl: 60000, dedupingInterval: 15000 });

  const getPriceToken = useCallback((address: string) => {
    if (!address || !priceToken) {
      return undefined;
    }
    return priceToken?.find((item) => item.address && item.address.toLowerCase() === address.toLowerCase());
  }, [ priceToken ]);

  return {
    priceAll,
    getPriceToken,
  };
}
